import { httpPost } from "../http"

export type v1GetTierNameBody = {}

export interface v1GetTierNameResponse {
  flag: number
  message: string
  data: Data
}

interface Data {
  tierName: string
  tierImage: string
  bePoint: number
  backgroundImage: string
  memberImage: string
  tier: number
  user_id: number
}

export function v1GetTierName(body: v1GetTierNameBody) {
  return httpPost<v1GetTierNameResponse>(
    "be-loyalty-user/customer/get-tier-name",
    body
  )
}
